
// import React, { useState, useMemo, useEffect } from "react";
// import { useApp } from "../../../context/AppContext";
// import { useToast } from "../../../context/ToastContext";
// import DataTable from "../../../components/DataTable/DataTable";
// import StatusBadge from "../../../components/StatusBadge/StatusBadge";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import Modal from "../../../components/Modal/Modal";
// import Button from "../../../components/Form/Button";
// import Input from "../../../components/Form/Input";
// import Select from "../../../components/Form/Select";
// import "./Pumps.css";
// import apiService from "../../../services/api";

// const AdminPumps = () => {
//   // safe defaults (AppContext should provide fetchPumps and optional setPumps)
//   const { pumps = [], setPumps, fetchPumps, users = [] } = useApp() || {};
//   const { showToast } = useToast() || {};
//   const [selectedPump, setSelectedPump] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [filters, setFilters] = useState({ search: "", city: "", active: "" });

//   // Manager list state (fetched from API)
//   const [managersList, setManagersList] = useState([]);
//   const [managersLoading, setManagersLoading] = useState(false);
//   const [managersError, setManagersError] = useState(null);

//   // The backend sometimes returns { data: [...] } or array directly.
//   const pumpData = Array.isArray(pumps) ? pumps : pumps?.data ?? [];

//   function safeParseFloat(v) {
//     if (v === undefined || v === null || v === "") return null;
//     const n = parseFloat(v);
//     return Number.isFinite(n) ? n : null;
//   }

//   /**
//    * Normalise incoming pump objects into a consistent shape
//    */
//   const normalizedPumps = useMemo(() => {
//     try {
//       if (!Array.isArray(pumpData)) return [];

//       return pumpData.map((p) => {
//         const id = p?._id || p?.id || p?.pump_id || null;
//         const pumpName = p?.brand || p?.pumpName || p?.name || "";
//         const city = p?.address?.locality || p?.city || "";
//         const address = p?.address
//           ? `${p.address.locality || ""}, ${p.address.state || ""} ${
//               p.address.pin_code || ""
//             }`.trim()
//           : typeof p?.address === "string"
//           ? p.address
//           : "";
//         const latitude = safeParseFloat(p?.address?.latitude ?? p?.latitude);
//         const longitude = safeParseFloat(p?.address?.longitude ?? p?.longitude);
//         const managerId =
//           p?.manager?._id || p?.managerId || p?.manager_id || null;
//         const managerName =
//           p?.manager?.name || p?.managerName || p?.manager_name || "";
//         const managerPhone =
//           p?.manager?.phone || p?.managerPhone || p?.manager_phone || "";
//         const commissionPercent =
//           typeof p?.commissionPercent !== "undefined"
//             ? Number(p.commissionPercent)
//             : typeof p?.commission === "number"
//             ? p.commission
//             : 5;
//         const active =
//           typeof p?.is_open !== "undefined"
//             ? !!p.is_open
//             : typeof p?.active !== "undefined"
//             ? !!p.active
//             : typeof p?.is_active !== "undefined"
//             ? !!p.is_active
//             : true;

//         return {
//           __raw: p,
//           id,
//           pumpId: id,
//           pumpName,
//           city,
//           address,
//           latitude,
//           longitude,
//           managerId,
//           managerName,
//           managerPhone,
//           commissionPercent,
//           active,
//           opening_time: p?.opening_time || "",
//           closing_time: p?.closing_time || "",
//           rate: p?.rate ?? p?.tariff ?? "",
//           createdAt: p?.createdAt || "",
//           updatedAt: p?.updatedAt || "",
//         };
//       });
//     } catch (err) {
//       console.error("Error normalizing pumps:", err);
//       return [];
//     }
//   }, [pumps]);

//   // cities computed from normalized pumps
//   const cities = useMemo(() => {
//     try {
//       return [
//         ...new Set(normalizedPumps.map((p) => p.city).filter(Boolean)),
//       ].sort();
//     } catch (err) {
//       console.error("Error computing cities:", err);
//       return [];
//     }
//   }, [normalizedPumps]);

//   // form data safe defaults
//   const [formData, setFormData] = useState({
//     brand: "",
//     pin_code: "",
//     locality: "",
//     state: "",
//     latitude: "",
//     longitude: "",
//     managerId: "",
//     managerName: "",
//     managerPhone: "",
//     opening_time: "",
//     closing_time: "",
//     rate: "",
//     active: true,
//   });

//   const filteredPumps = useMemo(() => {
//     try {
//       if (!Array.isArray(normalizedPumps)) return [];
//       return normalizedPumps.filter((pump) => {
//         if (!pump) return false;

//         if (filters.search) {
//           const search = String(filters.search).toLowerCase();
//           const hay =
//             `${pump.pumpName} ${pump.city} ${pump.managerName} ${pump.managerPhone}`.toLowerCase();
//           if (!hay.includes(search)) return false;
//         }
//         if (filters.city && pump.city !== filters.city) return false;
//         if (filters.active !== "") {
//           const activeFilterValue = filters.active === "true";
//           if (pump.active !== activeFilterValue) return false;
//         }
//         return true;
//       });
//     } catch (err) {
//       console.error("Error filtering pumps:", err);
//       return [];
//     }
//   }, [normalizedPumps, filters]);

//   const columns = [
//     { key: "pumpID", label: "Pump ID", render: (v, row) => row?.pumpId || "-" },
//     {
//       key: "pumpName",
//       label: "Pump Name",
//       render: (v, row) => row?.pumpName || "-",
//     },
//     { key: "city", label: "City", render: (v, row) => row?.city || "-" },
//     {
//       key: "managerName",
//       label: "Manager",
//       render: (v, row) => row?.managerName || "Unassigned",
//     },
//     {
//       key: "managerPhone",
//       label: "Phone",
//       render: (v, row) => row?.managerPhone || "-",
//     },
//     {
//       key: "commissionPercent",
//       label: "Commission %",
//       render: (v, row) => `${row?.commissionPercent ?? 0}%`,
//     },
//     {
//       key: "active",
//       label: "Status",
//       render: (v, row) => (
//         <StatusBadge status={row?.active ? "active" : "inactive"} type="user" />
//       ),
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       sortable: false,
//       render: (value, row) => (
//         <div className="table-actions">
//           <Button
//             size="small"
//             variant="outline"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleEdit(row);
//             }}
//           >
//             Edit
//           </Button>
//           <Button
//             size="small"
//             variant="danger"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleDeleteClick(row);
//             }}
//           >
//             Delete
//           </Button>
//         </div>
//       ),
//     },
//   ];

//   // --- MANAGERS: fetch from API and store in managersList ---
//   const fetchManagers = async (opts = {}) => {
//     try {
//       setManagersLoading(true);
//       setManagersError(null);
//       // Use existing API to get users, then filter managers.
//       const resp = await apiService.getUsers(opts?.config || {});

//       console.log("Managers list>>>>>>>>>>>:", resp);

//       // resp shape may be { data: { data: [...] } } or {...}
//       const arr = Array.isArray(resp)
//         ? resp
//         : resp?.data?.data ?? resp?.data ?? [];
//       if (!Array.isArray(arr)) {
//         setManagersList([]);
//         return [];
//       }
//       const mgrs = arr
//         .filter((u) => {
//           const role = (u?.role ?? u?.user_type ?? u?.userType ?? "")
//             .toString()
//             .toLowerCase();
//           return role === "manager";
//         })
//         .map((u) => ({
//           id: u._id ?? u.id,
//           name: u.name ?? u.fullName ?? u.email ?? "Unknown",
//           phone: u.phone ?? u.mobile ?? "",
//           __raw: u,
//         }));

//       setManagersList(mgrs);
//       return mgrs;
//     } catch (err) {
//       console.warn("Failed to fetch managers", err);
//       setManagersError(err);
//       setManagersList([]);
//       if (showToast) showToast("Failed to load managers", "error");
//       return [];
//     } finally {
//       setManagersLoading(false);
//     }
//   };

//   // fetch managers on mount so select is ready
//   useEffect(() => {
//     fetchManagers();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Also fetch managers whenever modal opens to ensure fresh list
//   useEffect(() => {
//     if (isModalOpen) {
//       fetchManagers();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isModalOpen]);

//   // handlers
//   const handleAdd = () => {
//     setFormData({
//       brand: "",
//       pin_code: "",
//       locality: "",
//       state: "",
//       latitude: "",
//       longitude: "",
//       managerId: "",
//       managerName: "",
//       managerPhone: "",
//       opening_time: "",
//       closing_time: "",
//       rate: "",
//       active: true,
//     });
//     setSelectedPump(null);
//     setIsModalOpen(true);
//   };

//   const handleEdit = (pump) => {
//     if (!pump) return;
//     setFormData({
//       brand: pump.__raw?.brand ?? pump.pumpName ?? "",
//       pin_code: pump.__raw?.address?.pin_code ?? "",
//       locality: pump.__raw?.address?.locality ?? pump.city ?? "",
//       state: pump.__raw?.address?.state ?? "",
//       latitude: pump.latitude != null ? String(pump.latitude) : "",
//       longitude: pump.longitude != null ? String(pump.longitude) : "",
//       managerId: pump.managerId || pump.__raw?.manager?._id || "",
//       managerName: pump.managerName || pump.__raw?.manager?.name || "",
//       managerPhone: pump.managerPhone || pump.__raw?.manager?.phone || "",
//       opening_time: pump.opening_time || pump.__raw?.opening_time || "",
//       closing_time: pump.closing_time || pump.__raw?.closing_time || "",
//       rate: pump.rate || pump.__raw?.rate || "",
//       active: typeof pump.active === "boolean" ? pump.active : true,
//     });
//     setSelectedPump(pump);
//     setIsModalOpen(true);
//   };

//   const handleDeleteClick = (pump) => {
//     setSelectedPump(pump);
//     setIsDeleteModalOpen(true);
//   };

//   const handleDelete = async () => {
//     const idToDelete = selectedPump?.id;
//     if (!idToDelete) {
//       showToast?.("Cannot delete: invalid pump", "error");
//       setIsDeleteModalOpen(false);
//       setSelectedPump(null);
//       return;
//     }

//     try {
//       await apiService.deletePump(idToDelete);
//       if (typeof fetchPumps === "function") {
//         await fetchPumps();
//       } else if (typeof setPumps === "function") {
//         setPumps((prev) =>
//           Array.isArray(prev)
//             ? prev.filter((p) => String(p._id ?? p.id) !== String(idToDelete))
//             : prev
//         );
//       }
//       showToast?.("Pump deleted successfully", "success");
//     } catch (error) {
//       console.error("Error deleting pump:", error);
//       showToast?.("Failed to delete pump", "error");
//     } finally {
//       setIsDeleteModalOpen(false);
//       setSelectedPump(null);
//     }
//   };

//   // Manager select change now uses managersList (from API)
//   const handleManagerChange = (managerId) => {
//     const m = managersList.find((x) => String(x.id) === String(managerId));
//     setFormData((prev) => ({
//       ...prev,
//       managerId: managerId || "",
//       managerName: m?.name || "",
//       managerPhone: m?.phone || "",
//     }));
//   };

//   // ⬇️ NOW: location change ONLY updates latitude/longitude, not locality
//   const handleLocationChange = (lat, lng) => {
//     setFormData((prev) => ({
//       ...prev,
//       latitude: lat != null ? String(lat) : "",
//       longitude: lng != null ? String(lng) : "",
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !formData.brand?.trim() ||
//       !formData.locality?.trim() ||
//       !formData.state?.trim() ||
//       !formData.pin_code?.trim()
//     ) {
//       showToast?.("Please fill in all required fields", "error");
//       return;
//     }

//     const apiPayload = {
//       manager_id: formData.managerId || null,
//       brand: formData.brand,
//       address: {
//         pin_code: formData.pin_code,
//         locality: formData.locality,
//         state: formData.state,
//         is_default: true,
//         latitude: safeParseFloat(formData.latitude),
//         longitude: safeParseFloat(formData.longitude),
//       },
//       opening_time: formData.opening_time,
//       closing_time: formData.closing_time,
//       rate: parseFloat(formData.rate) || 0,
//     };

//     try {
//       if (selectedPump) {
//         const pumpId = selectedPump.id;
//         await apiService.updatePump(pumpId, apiPayload);
//         if (typeof fetchPumps === "function") await fetchPumps();
//         else if (typeof setPumps === "function") {
//           setPumps((prev) => {
//             if (!Array.isArray(prev)) return prev;
//             return prev.map((p) =>
//               String(p._id ?? p.id) === String(pumpId)
//                 ? { ...p, ...apiPayload }
//                 : p
//             );
//           });
//         }
//         showToast?.("Pump updated successfully", "success");
//       } else {
//         await apiService.createPump(apiPayload);
//         if (typeof fetchPumps === "function") await fetchPumps();
//         else if (typeof setPumps === "function") {
//           setPumps((prev) => (Array.isArray(prev) ? prev : []));
//         }
//         showToast?.("Pump added successfully", "success");
//       }
//       setIsModalOpen(false);
//       setSelectedPump(null);
//     } catch (error) {
//       console.error("Error saving pump:", error);
//       showToast?.("Failed to save pump", "error");
//     }
//   };

//   return (
//     <div className="admin-pumps">
//       <PageHeader
//         title="Petrol Pumps"
//         actions={
//           <Button variant="primary" onClick={handleAdd}>
//             + Add Pump
//           </Button>
//         }
//       />

//       <div className="pumps-filters">
//         <Input
//           label="Search by Name"
//           placeholder="Search pumps..."
//           value={filters.search}
//           onChange={(e) => setFilters({ ...filters, search: e.target.value })}
//         />
//         <Select
//           label="Filter by City"
//           value={filters.city}
//           onChange={(e) => setFilters({ ...filters, city: e.target.value })}
//           options={[
//             { value: "", label: "All Cities" },
//             ...cities.map((city) => ({ value: city, label: city })),
//           ]}
//         />
//         <Select
//           label="Filter by Status"
//           value={filters.active}
//           onChange={(e) => setFilters({ ...filters, active: e.target.value })}
//           options={[
//             { value: "", label: "All Status" },
//             { value: "true", label: "Active" },
//             { value: "false", label: "Inactive" },
//           ]}
//         />
//       </div>

//       <DataTable
//         columns={columns}
//         data={Array.isArray(filteredPumps) ? filteredPumps : []}
//         searchable={false}
//       />

//       {/* Add/Edit Modal */}
//       <Modal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//           setSelectedPump(null);
//         }}
//         title={selectedPump ? "Edit Pump" : "Add New Pump"}
//         size="large"
//       >
//         <form onSubmit={handleSubmit} className="pump-form">
//           <div className="form-row">
//             <Input
//               label="Brand *"
//               value={formData.brand}
//               onChange={(e) =>
//                 setFormData({ ...formData, brand: e.target.value })
//               }
//               required
//             />
//             <Input
//               label="Locality *"
//               value={formData.locality}
//               onChange={(e) =>
//                 setFormData({ ...formData, locality: e.target.value })
//               }
//               required
//             />
//           </div>

//           <div className="form-row">
//             <Input
//               label="State *"
//               value={formData.state}
//               onChange={(e) =>
//                 setFormData({ ...formData, state: e.target.value })
//               }
//               required
//             />
//             <Input
//               label="Pin Code *"
//               value={formData.pin_code}
//               onChange={(e) =>
//                 setFormData({ ...formData, pin_code: e.target.value })
//               }
//               required
//             />
//           </div>

//           <LocationPicker
//             address={formData.locality} // only used as initial value
//             latitude={formData.latitude}
//             longitude={formData.longitude}
//             onLocationChange={handleLocationChange}
//             showToast={showToast}
//           />

//           <div className="form-row">
//             <Select
//               label="Manager"
//               value={formData.managerId}
//               onChange={(e) => handleManagerChange(e.target.value)}
//               options={[
//                 { value: "", label: "Unassigned" },
//                 ...managersList.map((m) => ({
//                   value: m.id,
//                   label: `${m.name} ${m.phone ? `(${m.phone})` : ""}`,
//                 })),
//               ]}
//               disabled={managersLoading}
//             />
//             <Input
//               label="Manager Phone"
//               value={formData.managerPhone}
//               // onChange={(e) =>
//               //   setFormData({ ...formData, managerPhone: e.target.value })
//               // }
//               // ⬇️ phone is now ALWAYS editable
//             />
//           </div>

//           <div className="form-row">
//             <Input
//               label="Opening Time"
//               type="time"
//               value={formData.opening_time}
//               onChange={(e) =>
//                 setFormData({ ...formData, opening_time: e.target.value })
//               }
//             />
//             <Input
//               label="Closing Time"
//               type="time"
//               value={formData.closing_time}
//               onChange={(e) =>
//                 setFormData({ ...formData, closing_time: e.target.value })
//               }
//             />
//           </div>

//           <div className="form-row">
//             <Input
//               label="Rate"
//               type="number"
//               value={formData.rate}
//               onChange={(e) =>
//                 setFormData({ ...formData, rate: e.target.value })
//               }
//               min="0"
//               step="0.01"
//             />
//             <div className="form-group">
//               <label className="form-label">Status</label>
//               <div className="toggle-switch-wrapper">
//                 <label className="toggle-switch">
//                   <input
//                     type="checkbox"
//                     checked={!!formData.active}
//                     onChange={(e) =>
//                       setFormData({ ...formData, active: e.target.checked })
//                     }
//                   />
//                   <span className="toggle-slider"></span>
//                 </label>
//                 <span className="toggle-label">
//                   {formData.active ? "Active" : "Inactive"}
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div className="modal-actions">
//             <Button
//               type="button"
//               variant="outline"
//               onClick={() => {
//                 setIsModalOpen(false);
//                 setSelectedPump(null);
//               }}
//             >
//               Cancel
//             </Button>
//             <Button type="submit" variant="primary">
//               {selectedPump ? "Update Pump" : "Add Pump"}
//             </Button>
//           </div>
//         </form>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal
//         isOpen={isDeleteModalOpen}
//         onClose={() => {
//           setIsDeleteModalOpen(false);
//           setSelectedPump(null);
//         }}
//         title="Delete Pump"
//         size="small"
//       >
//         <div className="delete-confirmation">
//           <p>
//             Are you sure you want to delete{" "}
//             <strong>
//               {selectedPump?.pumpName || selectedPump?.pumpId || "this pump"}
//             </strong>
//             ?
//           </p>
//           <p className="warning-text">This action cannot be undone.</p>
//           <div className="modal-actions">
//             <Button
//               variant="outline"
//               onClick={() => {
//                 setIsDeleteModalOpen(false);
//                 setSelectedPump(null);
//               }}
//             >
//               Cancel
//             </Button>
//             <Button variant="danger" onClick={handleDelete}>
//               Delete
//             </Button>
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// // LocationPicker with backend geocoding
// const LocationPicker = ({
//   address,
//   latitude,
//   longitude,
//   onLocationChange,
//   showToast,
// }) => {
//   // use locality only as INITIAL default, then keep independent
//   const [searchValue, setSearchValue] = useState(address || "");
//   const [isSearching, setIsSearching] = useState(false);

//   const handleAddressChange = (e) => {
//     const value = e.target.value;
//     setSearchValue(value);
//     // ❌ no longer touching locality here
//     // ❌ no longer resetting lat/lng here
//   };

//   const handleMapClick = () => {
//     if (latitude && longitude) {
//       window.open(
//         `https://www.google.com/maps?q=${latitude},${longitude}&z=15`,
//         "_blank"
//       );
//     }
//   };

//   const handleSearchClick = async () => {
//     const query = searchValue.trim();
//     if (!query) return;

//     try {
//       setIsSearching(true);

//       // Call your backend geocoding endpoint via apiService
//       const resp = await apiService.geoLocateAddress({ address: query });

//       console.log("Geo-location response:", resp);

//       // geoLocateAddress returns response.data
//       // backend: { error, data: { formattedAddress, latitude, longitude, ... } }
//       const geoPayload = resp?.data ?? resp ?? {};

//       const lat = geoPayload?.latitude;
//       const lng = geoPayload?.longitude;
//       const formatted =
//         geoPayload?.formattedAddress || geoPayload?.formatted_address || query;

//       if (lat == null || lng == null) {
//         showToast?.(
//           "Could not fetch latitude/longitude for this address",
//           "error"
//         );
//         return;
//       }

//       // Update ONLY lat/lng in parent
//       if (typeof onLocationChange === "function") {
//         onLocationChange(lat, lng);
//       }

//       // Keep search box in sync with the formatted address (nice UX)
//       setSearchValue(formatted);

//       showToast?.("Location fetched from Google Maps", "success");
//     } catch (err) {
//       console.error("Geo-location lookup failed:", err);
//       showToast?.("Failed to fetch location. Try again.", "error");
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   return (
//     <div className="location-picker">
//       {/* Search input + button */}
//       <div className="location-search-row">
//         <Input
//           label="Location Search"
//           placeholder="Enter address or search location"
//           value={searchValue}
//           onChange={handleAddressChange}
//         />
//         <Button
//           type="button"
//           variant="primary"
//           onClick={handleSearchClick}
//           disabled={!searchValue.trim() || isSearching}
//           style={{ marginTop: "24px", marginLeft: "8px" }}
//         >
//           {isSearching ? "Searching..." : "Search"}
//         </Button>
//       </div>

//       <div className="location-coords">
//         <Input
//           label="Latitude"
//           type="number"
//           step="any"
//           placeholder="e.g., 19.1364"
//           value={latitude || ""}
//           readOnly
//         />
//         <Input
//           label="Longitude"
//           type="number"
//           step="any"
//           placeholder="e.g., 72.8296"
//           value={longitude || ""}
//           readOnly
//         />
//       </div>

//       {latitude && longitude && (
//         <div className="map-preview">
//           <p className="map-note">
//             💡 <strong>Note:</strong> Coordinates are fetched from the backend
//             (Google Maps Geocoding).
//           </p>
//           <div className="map-embed">
//             <iframe
//               title="Location Preview"
//               width="100%"
//               height="200"
//               frameBorder="0"
//               style={{ border: 0 }}
//               src={`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
//               allowFullScreen
//             />
//           </div>
//           <Button
//             type="button"
//             variant="outline"
//             size="small"
//             onClick={handleMapClick}
//             className="view-map-button"
//           >
//             Open in Google Maps
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminPumps;



import React, { useState, useMemo, useEffect } from "react";
import { useApp } from "../../../context/AppContext";
import { useToast } from "../../../context/ToastContext";
import DataTable from "../../../components/DataTable/DataTable";
import StatusBadge from "../../../components/StatusBadge/StatusBadge";
import PageHeader from "../../../components/PageHeader/PageHeader";
import Modal from "../../../components/Modal/Modal";
import Button from "../../../components/Form/Button";
import Input from "../../../components/Form/Input";
import Select from "../../../components/Form/Select";
import "./Pumps.css";
import apiService from "../../../services/api";

const AdminPumps = () => {
  // safe defaults (AppContext should provide fetchPumps and optional setPumps)
  const { pumps = [], setPumps, fetchPumps, users = [] } = useApp() || {};
  const { showToast } = useToast() || {};
  const [selectedPump, setSelectedPump] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [filters, setFilters] = useState({ search: "", city: "", active: "" });

  // Manager list state (fetched from API)
  const [managersList, setManagersList] = useState([]);
  const [managersLoading, setManagersLoading] = useState(false);
  const [managersError, setManagersError] = useState(null);

  // The backend sometimes returns { data: [...] } or array directly.
  const pumpData = Array.isArray(pumps) ? pumps : pumps?.data ?? [];

  function safeParseFloat(v) {
    if (v === undefined || v === null || v === "") return null;
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : null;
  }

  /**
   * Normalise incoming pump objects into a consistent shape
   * Status is now driven by is_active from backend
   */
  const normalizedPumps = useMemo(() => {
    try {
      if (!Array.isArray(pumpData)) return [];

      return pumpData.map((p) => {
        const id = p?._id || p?.id || p?.pump_id || null;
        const pumpName = p?.brand || p?.pumpName || p?.name || "";
        const city = p?.address?.locality || p?.city || "";
        const address = p?.address
          ? `${p.address.locality || ""}, ${p.address.state || ""} ${
              p.address.pin_code || ""
            }`.trim()
          : typeof p?.address === "string"
          ? p.address
          : "";
        const latitude = safeParseFloat(p?.address?.latitude ?? p?.latitude);
        const longitude = safeParseFloat(p?.address?.longitude ?? p?.longitude);
        const managerId =
          p?.manager?._id || p?.managerId || p?.manager_id || null;
        const managerName =
          p?.manager?.name || p?.managerName || p?.manager_name || "";
        const managerPhone =
          p?.manager?.phone || p?.managerPhone || p?.manager_phone || "";
        const commissionPercent =
          typeof p?.commissionPercent !== "undefined"
            ? Number(p.commissionPercent)
            : typeof p?.commission === "number"
            ? p.commission
            : 5;

        // ⭐ Status: purely based on backend is_active
        const is_active =
          typeof p?.is_active !== "undefined" ? !!p.is_active : true;

        return {
          __raw: p,
          id,
          pumpId: id,
          pumpName,
          city,
          address,
          latitude,
          longitude,
          managerId,
          managerName,
          managerPhone,
          commissionPercent,
          is_active,          // original flag from backend
          active: is_active,  // used by UI (badge, filter, toggle)
          opening_time: p?.opening_time || "",
          closing_time: p?.closing_time || "",
          rate: p?.rate ?? p?.tariff ?? "",
          createdAt: p?.createdAt || "",
          updatedAt: p?.updatedAt || "",
        };
      });
    } catch (err) {
      console.error("Error normalizing pumps:", err);
      return [];
    }
  }, [pumps]);

  // cities computed from normalized pumps
  const cities = useMemo(() => {
    try {
      return [
        ...new Set(normalizedPumps.map((p) => p.city).filter(Boolean)),
      ].sort();
    } catch (err) {
      console.error("Error computing cities:", err);
      return [];
    }
  }, [normalizedPumps]);

  // form data safe defaults
  const [formData, setFormData] = useState({
    brand: "",
    pin_code: "",
    locality: "",
    state: "",
    latitude: "",
    longitude: "",
    managerId: "",
    managerName: "",
    managerPhone: "",
    opening_time: "",
    closing_time: "",
    rate: "",
    active: true,
  });

  const filteredPumps = useMemo(() => {
    try {
      if (!Array.isArray(normalizedPumps)) return [];
      return normalizedPumps.filter((pump) => {
        if (!pump) return false;

        if (filters.search) {
          const search = String(filters.search).toLowerCase();
          const hay =
            `${pump.pumpName} ${pump.city} ${pump.managerName} ${pump.managerPhone}`.toLowerCase();
          if (!hay.includes(search)) return false;
        }
        if (filters.city && pump.city !== filters.city) return false;
        if (filters.active !== "") {
          const activeFilterValue = filters.active === "true";
          if (pump.active !== activeFilterValue) return false;
        }
        return true;
      });
    } catch (err) {
      console.error("Error filtering pumps:", err);
      return [];
    }
  }, [normalizedPumps, filters]);

  const columns = [
    { key: "pumpID", label: "Pump ID", render: (v, row) => row?.pumpId || "-" },
    {
      key: "pumpName",
      label: "Pump Name",
      render: (v, row) => row?.pumpName || "-",
    },
    { key: "city", label: "City", render: (v, row) => row?.city || "-" },
    {
      key: "managerName",
      label: "Manager",
      render: (v, row) => row?.managerName || "Unassigned",
    },
    {
      key: "managerPhone",
      label: "Phone",
      render: (v, row) => row?.managerPhone || "-",
    },
    {
      key: "commissionPercent",
      label: "Commission %",
      render: (v, row) => `${row?.commissionPercent ?? 0}%`,
    },
    {
      key: "active",
      label: "Status",
      render: (v, row) => (
        <StatusBadge status={row?.active ? "active" : "inactive"} type="user" />
      ),
    },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (value, row) => (
        <div className="table-actions">
          <Button
            size="small"
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(row);
            }}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="danger"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteClick(row);
            }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  // --- MANAGERS: fetch from API and store in managersList ---
  const fetchManagers = async (opts = {}) => {
    try {
      setManagersLoading(true);
      setManagersError(null);
      // Use existing API to get users, then filter managers.
      const resp = await apiService.getUsers(opts?.config || {});

      console.log("Managers list>>>>>>>>>>>:", resp);

      // resp shape may be { data: { data: [...] } } or {...}
      const arr = Array.isArray(resp)
        ? resp
        : resp?.data?.data ?? resp?.data ?? [];
      if (!Array.isArray(arr)) {
        setManagersList([]);
        return [];
      }
      const mgrs = arr
        .filter((u) => {
          const role = (u?.role ?? u?.user_type ?? u?.userType ?? "")
            .toString()
            .toLowerCase();
          return role === "manager";
        })
        .map((u) => ({
          id: u._id ?? u.id,
          name: u.name ?? u.fullName ?? u.email ?? "Unknown",
          phone: u.phone ?? u.mobile ?? "",
          __raw: u,
        }));

      setManagersList(mgrs);
      return mgrs;
    } catch (err) {
      console.warn("Failed to fetch managers", err);
      setManagersError(err);
      setManagersList([]);
      if (showToast) showToast("Failed to load managers", "error");
      return [];
    } finally {
      setManagersLoading(false);
    }
  };

  // fetch managers on mount so select is ready
  useEffect(() => {
    fetchManagers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Also fetch managers whenever modal opens to ensure fresh list
  useEffect(() => {
    if (isModalOpen) {
      fetchManagers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  // handlers
  const handleAdd = () => {
    setFormData({
      brand: "",
      pin_code: "",
      locality: "",
      state: "",
      latitude: "",
      longitude: "",
      managerId: "",
      managerName: "",
      managerPhone: "",
      opening_time: "",
      closing_time: "",
      rate: "",
      active: true,
    });
    setSelectedPump(null);
    setIsModalOpen(true);
  };

  const handleEdit = (pump) => {
    if (!pump) return;
    setFormData({
      brand: pump.__raw?.brand ?? pump.pumpName ?? "",
      pin_code: pump.__raw?.address?.pin_code ?? "",
      locality: pump.__raw?.address?.locality ?? pump.city ?? "",
      state: pump.__raw?.address?.state ?? "",
      latitude: pump.latitude != null ? String(pump.latitude) : "",
      longitude: pump.longitude != null ? String(pump.longitude) : "",
      managerId: pump.managerId || pump.__raw?.manager?._id || "",
      managerName: pump.managerName || pump.__raw?.manager?.name || "",
      managerPhone: pump.managerPhone || pump.__raw?.manager?.phone || "",
      opening_time: pump.opening_time || pump.__raw?.opening_time || "",
      closing_time: pump.closing_time || pump.__raw?.closing_time || "",
      rate: pump.rate || pump.__raw?.rate || "",
      // ⭐ Make sure we derive active from is_active
      active:
        typeof pump.is_active === "boolean"
          ? pump.is_active
          : typeof pump.active === "boolean"
          ? pump.active
          : typeof pump.__raw?.is_active === "boolean"
          ? pump.__raw.is_active
          : true,
    });
    setSelectedPump(pump);
    setIsModalOpen(true);
  };

  const handleDeleteClick = (pump) => {
    setSelectedPump(pump);
    setIsDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    const idToDelete = selectedPump?.id;
    if (!idToDelete) {
      showToast?.("Cannot delete: invalid pump", "error");
      setIsDeleteModalOpen(false);
      setSelectedPump(null);
      return;
    }

    try {
      await apiService.deletePump(idToDelete);
      if (typeof fetchPumps === "function") {
        await fetchPumps();
      } else if (typeof setPumps === "function") {
        setPumps((prev) =>
          Array.isArray(prev)
            ? prev.filter((p) => String(p._id ?? p.id) !== String(idToDelete))
            : prev
        );
      }
      showToast?.("Pump deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting pump:", error);
      showToast?.("Failed to delete pump", "error");
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedPump(null);
    }
  };

  // Manager select change now uses managersList (from API)
  const handleManagerChange = (managerId) => {
    const m = managersList.find((x) => String(x.id) === String(managerId));
    setFormData((prev) => ({
      ...prev,
      managerId: managerId || "",
      managerName: m?.name || "",
      managerPhone: m?.phone || "",
    }));
  };

  // location change ONLY updates latitude/longitude, not locality
  const handleLocationChange = (lat, lng) => {
    setFormData((prev) => ({
      ...prev,
      latitude: lat != null ? String(lat) : "",
      longitude: lng != null ? String(lng) : "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.brand?.trim() ||
      !formData.locality?.trim() ||
      !formData.state?.trim() ||
      !formData.pin_code?.trim()
    ) {
      showToast?.("Please fill in all required fields", "error");
      return;
    }

    const apiPayload = {
      manager_id: formData.managerId || null,
      brand: formData.brand,
      address: {
        pin_code: formData.pin_code,
        locality: formData.locality,
        state: formData.state,
        is_default: true,
        latitude: safeParseFloat(formData.latitude),
        longitude: safeParseFloat(formData.longitude),
      },
      opening_time: formData.opening_time,
      closing_time: formData.closing_time,
      rate: parseFloat(formData.rate) || 0,
      // ⭐ Drive backend status from toggle
      is_active: !!formData.active,
    };

    try {
      if (selectedPump) {
        const pumpId = selectedPump.id;
        await apiService.updatePump(pumpId, apiPayload);
        if (typeof fetchPumps === "function") await fetchPumps();
        else if (typeof setPumps === "function") {
          setPumps((prev) => {
            if (!Array.isArray(prev)) return prev;
            return prev.map((p) =>
              String(p._id ?? p.id) === String(pumpId)
                ? { ...p, ...apiPayload }
                : p
            );
          });
        }
        showToast?.("Pump updated successfully", "success");
      } else {
        await apiService.createPump(apiPayload);
        if (typeof fetchPumps === "function") await fetchPumps();
        else if (typeof setPumps === "function") {
          setPumps((prev) => (Array.isArray(prev) ? prev : []));
        }
        showToast?.("Pump added successfully", "success");
      }
      setIsModalOpen(false);
      setSelectedPump(null);
    } catch (error) {
      console.error("Error saving pump:", error);
      showToast?.("Failed to save pump", "error");
    }
  };

  return (
    <div className="admin-pumps">
      <PageHeader
        title="Petrol Pumps"
        actions={
          <Button variant="primary" onClick={handleAdd}>
            + Add Pump
          </Button>
        }
      />

      <div className="pumps-filters">
        <Input
          label="Search by Name"
          placeholder="Search pumps..."
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
        <Select
          label="Filter by City"
          value={filters.city}
          onChange={(e) => setFilters({ ...filters, city: e.target.value })}
          options={[
            { value: "", label: "All Cities" },
            ...cities.map((city) => ({ value: city, label: city })),
          ]}
        />
        <Select
          label="Filter by Status"
          value={filters.active}
          onChange={(e) => setFilters({ ...filters, active: e.target.value })}
          options={[
            { value: "", label: "All Status" },
            { value: "true", label: "Active" },
            { value: "false", label: "Inactive" },
          ]}
        />
      </div>

      <DataTable
        columns={columns}
        data={Array.isArray(filteredPumps) ? filteredPumps : []}
        searchable={false}
      />

      {/* Add/Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedPump(null);
        }}
        title={selectedPump ? "Edit Pump" : "Add New Pump"}
        size="large"
      >
        <form onSubmit={handleSubmit} className="pump-form">
          <div className="form-row">
            <Input
              label="Brand *"
              value={formData.brand}
              onChange={(e) =>
                setFormData({ ...formData, brand: e.target.value })
              }
              required
            />
            <Input
              label="Locality *"
              value={formData.locality}
              onChange={(e) =>
                setFormData({ ...formData, locality: e.target.value })
              }
              required
            />
          </div>

          <div className="form-row">
            <Input
              label="State *"
              value={formData.state}
              onChange={(e) =>
                setFormData({ ...formData, state: e.target.value })
              }
              required
            />
            <Input
              label="Pin Code *"
              value={formData.pin_code}
              onChange={(e) =>
                setFormData({ ...formData, pin_code: e.target.value })
              }
              required
            />
          </div>

          <LocationPicker
            address={formData.locality} // only used as initial value
            latitude={formData.latitude}
            longitude={formData.longitude}
            onLocationChange={handleLocationChange}
            showToast={showToast}
          />

          <div className="form-row">
            <Select
              label="Manager"
              value={formData.managerId}
              onChange={(e) => handleManagerChange(e.target.value)}
              options={[
                { value: "", label: "Unassigned" },
                ...managersList.map((m) => ({
                  value: m.id,
                  label: `${m.name} ${m.phone ? `(${m.phone})` : ""}`,
                })),
              ]}
              disabled={managersLoading}
            />
            <Input
              label="Manager Phone"
              value={formData.managerPhone}
              // onChange={(e) =>
              //   setFormData({ ...formData, managerPhone: e.target.value })
              // }
              // ⬇️ phone is now ALWAYS editable
            />
          </div>

          <div className="form-row">
            <Input
              label="Opening Time"
              type="time"
              value={formData.opening_time}
              onChange={(e) =>
                setFormData({ ...formData, opening_time: e.target.value })
              }
            />
            <Input
              label="Closing Time"
              type="time"
              value={formData.closing_time}
              onChange={(e) =>
                setFormData({ ...formData, closing_time: e.target.value })
              }
            />
          </div>

          <div className="form-row">
            {/* <Input
              label="Rate"
              type="number"
              value={formData.rate}
              onChange={(e) =>
                setFormData({ ...formData, rate: e.target.value })
              }
              min="0"
              step="0.01"
            /> */}
            <div className="form-group">
              <label className="form-label">Status</label>
              <div className="toggle-switch-wrapper">
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={!!formData.active}
                    onChange={(e) =>
                      setFormData({ ...formData, active: e.target.checked })
                    }
                  />
                  <span className="toggle-slider"></span>
                </label>
                <span className="toggle-label">
                  {formData.active ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
          </div>

          <div className="modal-actions">
            <Button
              type="button"
              variant="outline"
              onClick={() => {
                setIsModalOpen(false);
                setSelectedPump(null);
              }}
            >
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              {selectedPump ? "Update Pump" : "Add Pump"}
            </Button>
          </div>
        </form>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setSelectedPump(null);
        }}
        title="Delete Pump"
        size="small"
      >
        <div className="delete-confirmation">
          <p>
            Are you sure you want to delete{" "}
            <strong>
              {selectedPump?.pumpName || selectedPump?.pumpId || "this pump"}
            </strong>
            ?
          </p>
          <p className="warning-text">This action cannot be undone.</p>
          <div className="modal-actions">
            <Button
              variant="outline"
              onClick={() => {
                setIsDeleteModalOpen(false);
                setSelectedPump(null);
              }}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Delete
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

// LocationPicker with backend geocoding
const LocationPicker = ({
  address,
  latitude,
  longitude,
  onLocationChange,
  showToast,
}) => {
  // use locality only as INITIAL default, then keep independent
  const [searchValue, setSearchValue] = useState(address || "");
  const [isSearching, setIsSearching] = useState(false);

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    // ❌ no longer touching locality here
    // ❌ no longer resetting lat/lng here
  };

  const handleMapClick = () => {
    if (latitude && longitude) {
      window.open(
        `https://www.google.com/maps?q=${latitude},${longitude}&z=15`,
        "_blank"
      );
    }
  };

  const handleSearchClick = async () => {
    const query = searchValue.trim();
    if (!query) return;

    try {
      setIsSearching(true);

      // Call your backend geocoding endpoint via apiService
      const resp = await apiService.geoLocateAddress({ address: query });

      console.log("Geo-location response:", resp);

      // geoLocateAddress returns response.data
      // backend: { error, data: { formattedAddress, latitude, longitude, ... } }
      const geoPayload = resp?.data ?? resp ?? {};

      const lat = geoPayload?.latitude;
      const lng = geoPayload?.longitude;
      const formatted =
        geoPayload?.formattedAddress || geoPayload?.formatted_address || query;

      if (lat == null || lng == null) {
        showToast?.(
          "Could not fetch latitude/longitude for this address",
          "error"
        );
        return;
      }

      // Update ONLY lat/lng in parent
      if (typeof onLocationChange === "function") {
        onLocationChange(lat, lng);
      }

      // Keep search box in sync with the formatted address (nice UX)
      setSearchValue(formatted);

      showToast?.("Location fetched from Google Maps", "success");
    } catch (err) {
      console.error("Geo-location lookup failed:", err);
      showToast?.("Failed to fetch location. Try again.", "error");
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <div className="location-picker">
      {/* Search input + button */}
      <div className="location-search-row">
        <Input
          label="Location Search"
          placeholder="Enter address or search location"
          value={searchValue}
          onChange={handleAddressChange}
        />
        <Button
          type="button"
          variant="primary"
          onClick={handleSearchClick}
          disabled={!searchValue.trim() || isSearching}
          style={{ marginTop: "24px", marginLeft: "8px" }}
        >
          {isSearching ? "Searching..." : "Search"}
        </Button>
      </div>

      <div className="location-coords">
        <Input
          label="Latitude"
          type="number"
          step="any"
          placeholder="e.g., 19.1364"
          value={latitude || ""}
          readOnly
        />
        <Input
          label="Longitude"
          type="number"
          step="any"
          placeholder="e.g., 72.8296"
          value={longitude || ""}
          readOnly
        />
      </div>

      {latitude && longitude && (
        <div className="map-preview">
          <p className="map-note">
            💡 <strong>Note:</strong> Coordinates are fetched from the backend
            (Google Maps Geocoding).
          </p>
          <div className="map-embed">
            <iframe
              title="Location Preview"
              width="100%"
              height="200"
              frameBorder="0"
              style={{ border: 0 }}
              src={`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
              allowFullScreen
            />
          </div>
          <Button
            type="button"
            variant="outline"
            size="small"
            onClick={handleMapClick}
            className="view-map-button"
          >
            Open in Google Maps
          </Button>
        </div>
      )}
    </div>
  );
};

export default AdminPumps;
